import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  MzModalComponent,
  MzModalService,
  MzToastService,
} from "ng2-materialize";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Project } from "../../interfaces/project";
import { ShareResponse } from "../../interfaces/shareResponse";
import { ProjectService } from "../../services/project/project.service";
import { SessionService } from "../../services/session/session.service";
import { ConfirmSyncComponent } from "../confirm-sync/confirm-sync.component";
import { VideoComponent } from "../video/video.component";
import { JiraImportComponent } from "../jira-import/jira-import.component";
import { JiraSyncProgressComponent } from "../jira-sync-progress/jira-sync-progress.component";

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectsComponent implements OnInit, AfterViewInit {
  env: any = environment;
  projects: Array<Project>;
  project = {} as Project;
  projectToShare: string;
  shareAddresses: string;
  selectedProject: Project;
  loading = true;
  emailValidateError = "Das E-Mail-Format ist ungültig.";
  emailIsInvalid = false;
  sharedNames: string;
  introVideo: string = "https://www.interaction-room.de/iris-videos/einfuehrung_volle_laenge.mp4";
  showAnnotations: Observable<boolean> = this.sessionService
    .getRoles()
    .map((x) => x.indexOf("annotations") >= 0);

  @ViewChild("JiraSyncProgressModal")
  JiraSyncProgressModal: JiraSyncProgressComponent;
  @ViewChild("introductionVideoModal") introductionVidoModal: MzModalComponent;
  @ViewChild("introductionVideo") introductionVideo: VideoComponent;

  constructor(
    private readonly projectService: ProjectService,
    private readonly toastService: MzToastService,
    private readonly modalService: MzModalService,
    private readonly sessionService: SessionService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  async ngOnInit() {
    await this.getProjects();
  }

  // to make sure that the required ViewChildren are loaded when they are accessed,
  // we use the AfterViewInit hook instead of OnInit.
  ngAfterViewInit() {
    this.enableIntroVideoOnFirstLogin();
  }

  private enableIntroVideoOnFirstLogin() {
    this.introductionVidoModal.onClose.subscribe(() =>
      this.introductionVideo.remove()
    );

    this.activatedRoute.params.subscribe((params) => {
      const firstLogin = params.firstLogin;
      if (firstLogin && (firstLogin === true || firstLogin === "true"))
        this.introductionVidoModal.open();
    });
  }

  /**
   * get all accessable project of user
   */
  async getProjects() {
    this.loading = true;
    let projects = await this.projectService.getProjects();
    this.projects = this.getSortedProjects(projects);
    this.loading = false;
  }

  /**
   * returns projects by created date
   * @type {Array<Project>}
   */
  private getSortedProjects(projects) {
    return projects.sort(
      (a: any, b: any) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
  }

  /**
   * Opens the dialog for importing JIRA projects
   */
  openJiraImportDialog() {
    const projectsComponent = this;
    const jiraImportComponent = <JiraImportComponent>(
      this.modalService.open(JiraImportComponent).instance
    );
    jiraImportComponent.projectCreated.subscribe((_) => {
      projectsComponent.projectService
        .getProjects()
        .then((projects: Array<Project>) => {
          projectsComponent.projects = this.getSortedProjects(projects);
        });
    });
  }

  /**
   * creates new project
   */
  createProject() {
    this.loading = true;
    if (this.project.name && this.project.name.trim() !== "") {
      this.project.name = this.project.name.trim();
      this.projectService
        .createProject(this.project)
        .then((project: Project) => {
          project.userIsOwner = true;
          this.projects.unshift(project);
          this.loading = false;
          this.project = {} as Project;
          this.toastService.show(
            "Neues Projekt erstellt!",
            4000,
            "confirm-toast"
          );
        });
    }
    this.loading = false;
  }

  /**
   * selectes current project and opens modal for sharing project
   * @param modal
   * @param project
   * @param $event
   */
  shareProjectById(modal, project, $event) {
    $event.stopPropagation();
    this.selectedProject = project;
    modal.open();
    setTimeout(() => {
      $($("#shareAddresses")[0]).focus();
    }, 100);
  }

  /**
   * set selectedProject to selected project
   * @param project
   * @param event
   */
  selectProject(project, event) {
    event.stopPropagation();
    this.selectedProject = project;
  }

  /**
   * end participation on selected project
   */
  endParticipation() {
    this.projectService.endParticipation(this.selectedProject._id).then(() => {
      this.getProjects();
    });
  }

  shareProject(modal) {
    if (this.selectedProject) {
      this.emailIsInvalid = false;
      this.loading = true;
      const projectId = this.selectedProject._id;
      const addresses = this.shareAddresses;
      this.projectToShare = undefined;
      this.shareAddresses = undefined;
      this.projectService
        .shareProject(projectId, addresses)
        .then((response: ShareResponse) => {
          this.loading = false;
          modal.close();
          response.results.forEach((x) => {
            switch (x.result) {
              case "user_is_owner":
                this.toastService.show(
                  "Du bist bereits Projektteilnehmer.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_already_added":
                this.toastService.show(
                  x.name + " ist bereits Projektteilnehmer.",
                  4000,
                  "notification-toast"
                ); //yellow
                break;

              case "error_adding_user":
                this.toastService.show(
                  x.name + " konnte dem Projekt nicht hinzugefügt werden.",
                  4000,
                  "notification-toast"
                ); //red
                break;

              case "user_added_but_sendmail_failed":
                this.toastService.show(
                  x.name +
                    " wurde dem Projekt hinzugefügt, aber es konnte keine Benachrichtigung verschickt werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_added":
                this.toastService.show(
                  x.name + " wurde eingeladen!",
                  4000,
                  "confirm-toast"
                );
                break;

              case "user_already_invited":
                this.toastService.show(
                  x.email + " wurde bereits eingeladen.",
                  4000,
                  "notification-toast"
                );
                break;

              case "error_creating_invitation":
                this.toastService.show(
                  x.email + " konnte nicht eingeladen werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "invitation_created_but_sendmail_failed":
                this.toastService.show(
                  x.email +
                    " wurde eingeladen, aber es konnte keine Benachrichtigung verschickt werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_invited":
                this.toastService.show(
                  x.email + " wurde eingeladen!",
                  4000,
                  "confirm-toast"
                );
                break;
            }
          });
          this.getProjects();
        })
        .catch(() => {
          this.toastService.show(
            addresses + " konnte dem Projekt nicht hinzugefügt werden.",
            4000,
            "notification-toast"
          ); //red
          this.emailIsInvalid = true;
          this.loading = false;
        });
    }
  }

  /**
   * gets triggert, when modal is opend and select first inpurfield
   */
  createItemModalTrigger() {
    setTimeout(() => {
      $("#itemName").focus();
    }, 100);
  }

  /**
   * geturns all names from an project as html formatet string
   * is uses for the tooltip
   * @param project
   * @returns {string}
   */
  getAllSharedNames(project) {
    this.sharedNames = project.owner.name + "<br>";
    for (let sharedUser of project.sharedUsers) {
      this.sharedNames = this.sharedNames.concat(sharedUser.name + "<br>");
    }
    for (let invitedUser of project.invitations) {
      this.sharedNames = this.sharedNames.concat(invitedUser.email + "<br>");
    }
    return this.sharedNames;
  }

  async syncProject(project) {
    let result = await (<ConfirmSyncComponent>(
      this.modalService.open(ConfirmSyncComponent).instance
    )).result
      .asObservable()
      .first()
      .toPromise();
    if (result === true) {
      await this.JiraSyncProgressModal.sync(project.shortId);
      this.toastService.show(
        "Erfolgreich synchronisiert!",
        4000,
        "confirm-toast"
      );
      this.loading = true;
      await this.getProjects();
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/projects/projects.component.ts